import useSWR from "swr";
import { ChoiceEmployee } from "../../../globals/interfaces";
import { customFetcher } from "../../../utils";
import useUser from "../../../customHooks/useUser";

export default function useEmployees () {
    
    const { user } = useUser();
    const {
        data: employees
    } = useSWR(`/inventory-dev/employees/${user.s_unit}`, customFetcher<ChoiceEmployee>, {
        fallbackData: []
    });
    
    return {
        employees
    }
}